import { render, staticRenderFns } from "./TestimonialTemplate.vue?vue&type=template&id=2a346883&"
import script from "./TestimonialTemplate.vue?vue&type=script&lang=js&"
export * from "./TestimonialTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports